<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <v-icon>
        mdi-comment-plus-outline
      </v-icon>
      Add Assessment
    </SecondaryButton>
    <AssessmentDialog
      :isOpen="isOpen"
      @close="closeDialog"
      :applications="applications"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import AssessmentDialog from "@/views/bookings/Assessment/AssessmentDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "AddAssessmentAction",
  components: {
    BaseAction,
    AssessmentDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    applications: {
      type: Array,
      required: true
    }
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
